module.exports = __webpack_public_path__ + "img/c.cb9927f0.png";